<template>
  <div>
    <div class="row">
      <div class="col-12 ps-0">
        <div class="col-12 mt-3 mb-2"
             style="font-weight: bold;
             font-size: 18px;
             border-bottom: 1px solid #ddd;">
          {{ title }}
        </div>
      </div>

      <!-- Loop through items and render inputs -->
      <div class="col-12" v-for="(item, index) in items" :key="index">
        <div class="row mt-5">
          <BaseInput v-model="item.id" hidden="hidden"/>

          <div class="col-lg-6 col-md-6 col-sm-12">
            <BaseInput v-model="item.title" :label="itemTitleLabel"/>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12">
            <TextEditor
                v-model="item.description"
                @update:model-value="item.description = $event"
                :inputStyle="{ height: '200px' }"
                :label="itemDescriptionLabel"/>
          </div>
        </div>


        <button
            class="btn btn-danger mt-2"
            v-if="items && items.length > 0"
            @click.prevent="deleteItem(index)">
          Löschen
        </button>
      </div>
    </div>

    <!-- Add Button -->
    <div class="text-end mb-5">
      <button type="button" class="btn btn-primary" @click.prevent="addItem">
        +
      </button>
    </div>
  </div>
</template>

<script setup>
import BaseInput from '@/components/base/BaseInput.vue';
import TextEditor from '@/components/TextEditor.vue';
import { defineEmits, defineProps } from 'vue';

// Props
defineProps({
  title: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  itemTitleLabel: {
    type: String,
    default: 'Title',
  },
  itemDescriptionLabel: {
    type: String,
    default: 'Description',
  },
  itemSelectPlaceholder: {
    type: String,
    required: false,
    default: 'Wert auswählen',
  },
  dropdownOptions: {
    type: Array,
    default: () => [],
  },
});

// Emits
const emit = defineEmits([ 'addItem', 'deleteItem' ]);

// Helper Methods
const addItem    = () => {
  emit('addItem', { title: '', description: '' });
};
const deleteItem = (index) => {
  emit('deleteItem', index);
};
</script>

<style scoped>
/* Add component-specific styles here if necessary */
</style>
